import * as React from 'react'

import Button from '@material-ui/core/Button/Button'
import Grid from '@material-ui/core/Grid/Grid'
import Hidden from '@material-ui/core/Hidden/Hidden'
import AddIcon from '@material-ui/icons/Add'
import FileDownloadIcon from '@material-ui/icons/FileDownload'
import HistoryIcon from '@material-ui/icons/History'


import { ActionButton } from '../atoms'
import DownloadExport from '../organisms/DownloadExport'

interface ProgramsBarProps {
  companiesFetching?: boolean
  onAddClick?: () => void
  exportRequest?: any
  onHistoryClick?: () => void
  history_active: string
}

interface MyState {
  isOpen: boolean
}
class ProgramsBar extends React.Component<ProgramsBarProps, MyState> {
  public inputRef
  constructor(props) {
    super(props)
    this.inputRef = React.createRef();
    this.state = {
      isOpen: false
    }
  }

  render() {
    const {
      onAddClick,
      companiesFetching,
      exportRequest,
      onHistoryClick,
      history_active,
    } = this.props
    return (
      <Grid
        container
        spacing={24}
        justify={'flex-end'}
        alignItems={'center'}
      >
         <Grid item>
          <Hidden xsDown>
          <ActionButton
              disabled={companiesFetching}
              color={'primary'}
              onClick={onHistoryClick}
              variant={'raised'}
              actionType={history_active}
            />
          </Hidden>
          <Hidden smUp>
            <Button
              disabled={companiesFetching}
              color={'primary'}
              onClick={onHistoryClick}
              variant={'raised'}
            >
              <HistoryIcon />
            </Button>
          </Hidden>
        </Grid>
        <Grid item>
          <DownloadExport
            fileName={'programs.xlsx'}
            fileRequest={exportRequest}
          >
            {({ loaded }) => (
              <>
                <Hidden xsDown>
                  <ActionButton
                    disabled={!loaded}
                    color={'primary'}
                    actionType={'download'}
                    variant={'raised'}
                  />
                </Hidden>
                <Hidden smUp>
                  <Button
                    disabled={!loaded}
                    color={'primary'}
                    variant={'raised'}
                  >
                    <FileDownloadIcon />
                  </Button>
                </Hidden>
              </>
            )}
          </DownloadExport>
        </Grid>
        <Grid item>
          <Hidden xsDown>
            <ActionButton
              disabled={companiesFetching}
              color={'primary'}
              onClick={onAddClick}
              actionType={'add'}
              variant={'raised'}
            />
          </Hidden>
          <Hidden smUp>
            <Button
              disabled={companiesFetching}
              color={'primary'}
              onClick={onAddClick}
              variant={'raised'}
            >
              <AddIcon />
            </Button>
          </Hidden>
        </Grid>
      </Grid>
    )
  }
}

export default ProgramsBar



// WEBPACK FOOTER //
// ./src/components/molecules/ProgramsBar.tsx